import React from 'react';
import PropTypes from 'prop-types';
import SrLink from 'client/components/SrLink/SrLink';
import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';
import SrBox from 'client/components/SrBox';

const SrCardLink = ({ to, thumbnailUrl, title, label, sublabel }) => {
  return (
    <SrBox
      className="SrCardLink"
      position="relative"
      boxShadow="0px 9px 18px rgba(25, 51, 64, 0.07)"
      backgroundColor="#FFFFFF"
      padding="15px"
      marginBottom="7px"
      borderRadius="14px"
    >
      <SrLink to={to}>
        <SrFlex>
          <SrBox paddingRight="10px">
            <img
              width="80"
              height="75"
              alt={thumbnailUrl}
              src={thumbnailUrl}
              style={{ borderRadius: '7px' }}
              className="dropshadow-bottom-edge"
            />
          </SrBox>
          <SrFlex justify="between" direction="col" className="width-100">
            {title && (
              <SrText
                size="larger"
                weight="bolder"
                display="block"
                font="greycliff"
                paddingRight="25px"
              >
                {title}
              </SrText>
            )}
            {label && (
              <SrText
                size="medium"
                weight="medium"
                display="block"
                font="greycliff"
                paddingTop="2px"
                className="ellipsis-25"
              >
                {label}
              </SrText>
            )}
            {sublabel && (
              <SrText size="medium" weight="medium" color="green" display="block" font="greycliff">
                {sublabel}
              </SrText>
            )}
          </SrFlex>
        </SrFlex>
        <SrBox position="absolute" right="15px" top="20px">
          <img
            width="7px"
            height="10px"
            src="/images/arrow-small-right-blue-curved.svg"
            alt="icon"
          />
        </SrBox>
      </SrLink>
    </SrBox>
  );
};

SrCardLink.propTypes = {
  to: PropTypes.string.isRequired,
  thumbnailUrl: PropTypes.string,
  title: PropTypes.string,
  label: PropTypes.string,
  sublabel: PropTypes.string,
};

SrCardLink.displayName = 'SrCardLinkLink';

export default SrCardLink;
